import { render, staticRenderFns } from "./TagLook.vue?vue&type=template&id=24a5f2de&scoped=true&"
import script from "./TagLook.vue?vue&type=script&lang=js&"
export * from "./TagLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5f2de",
  null
  
)

export default component.exports